import React from "react";
import profile from './profile.jpg';

const ProfilePhoto = ()=>{
    return (
      <div className="mainPar">
      <div className="photoChild">
        <img className="profileJPG" src={profile} alt="profile" />  
        </div>  

      <div className="aboutmeChild">
        <h2>01_ABOUT ME</h2>
        <h2>Hi, I'm Yvonne Armelia</h2>
        <h3>Passionate Front End Developer, Conceptual Creative and Killer Storyteller.</h3>
        <p>
            I'm 25 years old, based in Jakarta, Indonesia. 
        <br /><br />I describe myself as a developer who loves coding and design. 
        <br />Currently, I'm finishing my full stack JavaScript cooding bootcamp at
        <br /><a href="https://impactbyte.com/" target="_blank">Impact Byte Jakarta.</a>
        <br />
        <br />
            In my spare time I like to practice my design and coding skill.
        <br />That helps me to learn a lots of new stuff and grow as a developer. 
        <br />I love travelling and discovering new places.
        <br />
            Also, I enjoy writing at my blog and Wattpad. And ... I love my cat so much!
        <br /><br />
            Kindly check my project and let me know if you interested!
        <br /><br /><b>Thank you! xoxo &hearts;</b>
        </p>
      </div>
  </div>
    );
};

export default ProfilePhoto